import React from 'react';
import {Link} from "react-router-dom";
import Button from "@material-ui/core/Button";
import * as routes from "../constants/routes";
import {compose} from "recompose";
import {withAuth} from "../firebase/context";


class LogoutButton extends React.PureComponent {

    render() {
        if (this.props.auth.tryGetCurrentUser()) {
            return (
                <Link to={routes.landing}>
                    <Button
                        style={{color: '#fff'}}
                        onClick={(event) => {
                            this.props.auth.trySignOut();
                        }}>
                        Logout
                    </Button>
                </Link>
            )
        }

        return (
            <Link to={routes.admin}>
                <Button style={{color: '#fff'}}>Admin</Button>
            </Link>
        );
    }
}

export default compose(
    withAuth,
)(LogoutButton);


